/**
 * Initialize Activity Card Hover Videos
 */
import Hls from 'hls.js';

function InitActivityCards() {
    const activityCards = document.querySelectorAll('.activity-card');

    if (activityCards.length === 0) {
        return;
    }

    activityCards.forEach((card) => {
        const video = card.querySelector('.activity-hover-video');
        const image = card.querySelector('.activity-featured-image');

        if (!video) {
            return; // No video, just show image normally
        }

        const source = video.querySelector('source');
        if (!source) {
            return;
        }

        const videoSrc = source.src;
        let hls = null;
        let videoInitialized = false;

        // Initialize HLS
        function initializeVideo() {
            if (Hls.isSupported()) {
                hls = new Hls({
                    autoStartLoad: true,
                    startLevel: 2,
                    capLevelToPlayerSize: true,
                    maxBufferLength: 5,
                });

                hls.loadSource(videoSrc);
                hls.attachMedia(video);

                hls.on(Hls.Events.MANIFEST_PARSED, function() {
                    console.log('HLS manifest parsed, ready to play');
                });

                hls.on(Hls.Events.ERROR, function(event, data) {
                    console.error('HLS error:', data);
                });
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = videoSrc;
            }
        }

        // Check if mobile
        function isMobile() {
            return window.innerWidth < 768;
        }

        // Mobile: Use Intersection Observer for autoplay when in view
        if (isMobile()) {
            // Initialize video immediately for mobile
            initializeVideo();
            videoInitialized = true;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Video is in view - play it
                        video.play().then(() => {
                            video.style.opacity = '1';
                            if (image) image.style.opacity = '0';
                        }).catch(e => console.log('Video play failed:', e));
                    } else {
                        // Video is out of view - pause it
                        video.pause();
                        video.style.opacity = '0';
                        if (image) image.style.opacity = '1';
                    }
                });
            }, {
                threshold: 0.5 // Trigger when 50% of video is visible
            });

            observer.observe(card);
        } else {
            // Desktop: Use hover behavior
            card.addEventListener('mouseenter', function() {
                if (!videoInitialized) {
                    initializeVideo();
                    videoInitialized = true;

                    // Wait a moment for HLS to initialize
                    setTimeout(() => {
                        video.play().then(() => {
                            video.style.opacity = '1';
                            if (image) image.style.opacity = '0';
                        }).catch(e => console.log('Video play failed:', e));
                    }, 500);
                } else {
                    video.play().then(() => {
                        video.style.opacity = '1';
                        if (image) image.style.opacity = '0';
                    }).catch(e => console.log('Video play failed:', e));
                }
            });

            card.addEventListener('mouseleave', function() {
                video.pause();
                video.style.opacity = '0';
                if (image) image.style.opacity = '1';
            });
        }
    });
}

export default InitActivityCards;
